var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l2 = _vm.__map(_vm.dataList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var l0 = _vm.__map(
      item.goodsorderDetailList || [],
      function (item1, index1) {
        var $orig = _vm.__get_orig(item1)
        var g0 = (item1.price || 0).toFixed(2)
        return {
          $orig: $orig,
          g0: g0,
        }
      }
    )
    var l1 = _vm.__map(
      item.goodsorderDetailList || [],
      function (item1, index1) {
        var $orig = _vm.__get_orig(item1)
        var g1 = (item1.price || 0).toFixed(2)
        return {
          $orig: $orig,
          g1: g1,
        }
      }
    )
    var g2 = (item.price || 0).toFixed(2)
    return {
      $orig: $orig,
      l0: l0,
      l1: l1,
      g2: g2,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }